import axios from 'axios'

export default async (val) => {
    const req = {
        cardNo: val,
    };
    // const {data} = axios.get('/ej-isp-api/get/bankName', {params: req})
    // console.log(data);
}



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/bankName.js